/* eslint-disable max-len */
import Icon, { IconProps } from './icon';
import React from 'react';

export const PlusIcon: React.FC<Omit<IconProps, 'children'>> = ({
  size = 16,
  title = 'Plus',
  className,
  ...rest
}) => {
  return (
    <Icon size={size} title={title} viewBox="0 0 16 16" className={className} {...rest}>
      <path
        d="M8.6665 3.33334C8.6665 2.96515 8.36803 2.66667 7.99984 2.66667C7.63165 2.66667 7.33317 2.96515 7.33317 3.33334V7.33334H3.33317C2.96498 7.33334 2.6665 7.63182 2.6665 8.00001C2.6665 8.3682 2.96498 8.66667 3.33317 8.66667H7.33317V12.6667C7.33317 13.0349 7.63165 13.3333 7.99984 13.3333C8.36803 13.3333 8.6665 13.0349 8.6665 12.6667V8.66667H12.6665C13.0347 8.66667 13.3332 8.3682 13.3332 8.00001C13.3332 7.63182 13.0347 7.33334 12.6665 7.33334H8.6665V3.33334Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </Icon>
  );
};
